import maplibregl from 'maplibre-gl';
import Location from '../Location.js';

class Popups {
    constructor(map) {
        this.map = map;

        if(window.activeLocationId === undefined) {
            // Create unattached popup for later use
            this.popup = new maplibregl.Popup({
                closeButton: true,
                closeOnClick: true
            });

            this.setup();
            this.setCursorIcon();
        }
    }

    setup() {
        this.map.on('click', 'unclustered-point', (e) => {
            // Original center
            const center = this.map.getCenter();

            // Get feature properties
            const coordinates = e.features[0].geometry.coordinates.slice();
            const { id, title, thumbnail } = e.features[0].properties;

            // MapLibre-GL internally stringifies these, so turn them back into objects
            const address = JSON.parse(e.features[0].properties.address);
            const services = JSON.parse(e.features[0].properties.services);

            // Ensure the popup appears over the correct copy of the feature (important for maps that wrap)
            while (Math.abs(e.lngLat.lng - coordinates[0]) > 180) {
                coordinates[0] += e.lngLat.lng > coordinates[0] ? 360 : -360;
            }

            // Fly to top-left corner on smartphones, so the popup has space initially
            if (window.innerWidth < 600) {
                this.map.flyTo({
                    center: this.getTopLeftCorner(coordinates),
                    essential: true
                });
            }

            this.popup
                .setLngLat(coordinates)
                .setHTML(`
                    <div class="loc-image"><img src="${thumbnail}" alt="Standortbild ${title}"/></div>
                    <div class="details">
                        <address>${address.street}, ${address.zipcode} ${address.city}</address>
                        <div class="services">${new Location(id).getServicesAsHtml(services)}</div>
                    </div>
                `)
                .addTo(this.map);

            // Fly back to original center on smartphones, when popup closes
            if (window.innerWidth < 600) {
                this.popup.on('close', () => {
                    this.map.flyTo({
                        center: center,
                        essential: true
                    });
                });
            }
        });

        // Close popup on map scroll (wheel) or drag
        this.map.on('movestart', () => {
            this.popup.remove();
        });
    }

    getTopLeftCorner(coordinates) {
        // Convert coordinates to pixel position
        const pointPixel = this.map.project(coordinates);

        // Desired pixel position: near top-left corner
        const targetPixel = { x: 10, y: 45 };

        // Compute offset in pixels
        const dx = targetPixel.x - pointPixel.x;
        const dy = targetPixel.y - pointPixel.y;

        // Current center in pixels
        const centerPixel = this.map.project(this.map.getCenter());

        // New center in pixels
        const newCenterPixel = {
            x: centerPixel.x - dx,
            y: centerPixel.y - dy
        };

        // Convert back to lng/lat
        return this.map.unproject([newCenterPixel.x, newCenterPixel.y]);
    }

    // Set mouse cursor icon
    setCursorIcon() {
        this.map.on('mouseenter', 'unclustered-point', () => {
            this.map.getCanvas().style.cursor = 'pointer';
        });
        this.map.on('mouseleave', 'unclustered-point', () => {
            this.map.getCanvas().style.cursor = '';
        });
    }
}

export default Popups;
